export default function getPermissionSelected(permissionTableau) {
  const listPermission = [];
  permissionTableau.forEach((module) => {
    module.categorie.forEach((categorie) => {
      categorie.droit.forEach((droit) => {
        if (droit.selected) { listPermission.push(droit.link); }
      });
    });
  });
  return listPermission;
}
